<script setup lang="ts">
import { UiButton, UiModal } from "@packages/component-library";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import { onMounted, ref } from "vue";

const router = useRouter();
const route = useRoute();
const { t } = useI18n();
const showModal = ref(false);

onMounted(() => {
  showModal.value = true;
});
</script>

<template>
  <UiModal
    v-model="showModal"
    hide-header
    size="s"
    @update:modelValue="router.push({ name: route.name })"
  >
    <template #default>
      <div class="success-order">
        <img src="@/assets/images/done.svg" alt="" />
        <h5>{{ t("publicOrdering.successModal.title") }}</h5>
        <p>
          {{ t("publicOrdering.successModal.description") }}
        </p>
      </div>
    </template>

    <template #footer>
      <div class="success-order__actions">
        <UiButton
          :label="t('system.goHome')"
          size="m"
          :to="{ name: 'HomeView' }"
          data-test-id="publicOrderingSuccess-button-homeRedirect"
        />
      </div>
    </template>
  </UiModal>
</template>

<style scoped lang="scss">
.success-order {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;

  > h5 {
    @include h4();
    text-align: center;
    color: var(--color-semantic-content-normal-primary);
    margin: calc($base-space * 4) 0 0;
  }

  > p {
    margin: calc($base-space * 2) 0 0;
    @include body-m();
    color: var(--color-semantic-content-normal-primary);
    text-align: center;
  }

  &__actions {
    width: 100%;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    gap: calc($base-space * 2);

    > a {
      width: 100%;
    }
  }
}
</style>
